// Internet Explorer 11 requires polyfills and partially supported by this project.
// import 'react-app-polyfill/ie11';
// import 'react-app-polyfill/stable';
import './i18n';
import './styles/app-base.css';
import './styles/app-components.css';
import './styles/app-utilities.css';
import ReactDOM from 'react-dom';
import App from 'app/App';
import * as serviceWorker from './serviceWorker';
import reportWebVitals from './reportWebVitals';

import {ApolloProvider} from "@apollo/client"
import client from 'app/graphql';

function installFirefoxIosScriptErrorWorkaround() {
  const userAgent = window?.navigator?.userAgent || '';
  const isIOS = /iPhone|iPad|iPod/i.test(userAgent);
  const isFirefox = /FxiOS/i.test(userAgent);

  if (!isIOS || !isFirefox) {
    return;
  }

  window.addEventListener(
    'error',
    function (event) {
      const message = event?.message || '';
      const filename = event?.filename || '';
      const hasRealErrorObject = !!event?.error;

      // Firefox iOS can emit a noisy Script error event with no file/error details.
      if (message === 'Script error.' && !filename && !hasRealErrorObject) {
        event.stopImmediatePropagation();
      }
    },
    true
  );
}

installFirefoxIosScriptErrorWorkaround();

// ReactDOM.render(<App />, document.getElementById('root'));

ReactDOM.render(
<ApolloProvider client={client}>
  <App />
</ApolloProvider>,
document.getElementById('root')
);

reportWebVitals();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
